import { computed } from 'vue'

export default {
    name: "ProfileSettingsHero",
    props: {
        userData: {
            type: Object,
            required: true
        },
    },
    setup(props) {
        const name = computed(() => 
            props.userData.firstname && props.userData.lastname 
                ? `${props.userData.firstname} ${props.userData.lastname}` 
                : null
        )

        const addressCombined = computed(() => 
            props.userData.address && props.userData.postalCode && props.userData.city 
                ? `${props.userData.address}, ${props.userData.postalCode} ${props.userData.city}` 
                : null
        )

        return {
            name,
            addressCombined
        }
        
    }
}